import React from "react";
import "./Sidebar.css";

type Props = {
  children: React.ReactNode;
};

export default function SidebarSubmenu({ children }: Props) {
  return <div className="sidebar-submenu">{children}</div>;
}
